import { useMutation } from "@tanstack/react-query";
import cmsClient from "src/services/cmsClient";

const createFullScreenTakeover = async (
	payload: Omit<CarouselBanner, "id">
) => {
	const url = "/homepage/admin/fullscreentakeover/";
	const response = await cmsClient.post<CarouselBanner>(url, payload);

	return response.data;
};

const useCreateFullScreenTakeover = () => {
	const mutation = useMutation(createFullScreenTakeover);

	return mutation;
};

export default useCreateFullScreenTakeover;
